export const URL_SIS_API = process.env.REACT_APP_SISAPI;
export const URL_UPGORA = 'https://upgora.aden.org/inicio/';
export const URL_REPO = process.env.REACT_APP_REPO;
export const IP_URL = 'http://ip-api.com/json/';
